module.exports = __webpack_public_path__ + "024a60bf54cb0efa9df198b408fd7f1f.svg";